import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {Input} from "../../../../../../shadCn/components/ui/input";
import AssetInfoSlide from "../../../../../../components/slide/sub/asset/AssetInfoSlide";
import CommonPagination from "../../../../../../components/table/movable/CommonPagination";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../../../components/pageTabs/pageTabsStorage";


function AssetListThumbType({data, date, dataHook, pageInfo}) {
    const navigate = useNavigate();
    const [searchTxt, setSearchTxt] = useState('');

    const inputListener = (e) => {
        setSearchTxt(e.target.value);
    };

    const handleOnKeyPress = e => {
        if (e.key === 'Enter') {

        }
    };

    const handleItemClick = (each) => {
        const id = each?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(each, "자산상세"),
            url: `/asset/${id}`,
        });
    };

    return (
        <div className="flex w-[100%]">
            <div className="list-container">
                <div className="list-container-top-search">
                    <Input value={searchTxt} onChange={inputListener} onKeyPress={handleOnKeyPress}/>
                </div>
                <div className="asset-thumbnail-container">
                    {data.map(each => (
                        <div
                            key={each.id}
                            className="asset-thumb-item mb-3 h-[120px] w-full cursor-pointer border bg-white p-1"
                            role="button"
                            tabIndex={0}
                            onClick={() => handleItemClick(each)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handleItemClick(each);
                                }
                            }}
                        >
                            <AssetInfoSlide data={each}/>
                        </div>
                    ))}
                </div>
                {data && data.length > 0 &&
                    <CommonPagination page={pageInfo} onPageChange={dataHook.handlePageChange}/>
                }
            </div>
        </div>
    );
}

export default AssetListThumbType;
